module.exports = __webpack_public_path__ + "img/86.e983d512.jpg";